@if (announcement_id >= 0) {
  <div class="announcement-card">
    <div class="announcement-header">
      <mat-icon class="announcement-icon">campaign</mat-icon>
      <h4 class="announcement-title">{{ announcement_title }}</h4>
    </div>
    <p class="announcement-body">{{ announcement_body }}</p>
    @if (isAdmin) {
      <button class="announcement-delete" (click)="removeAnnouncement(announcement_id)">
        {{ 'delete' | translate }}
      </button>
    }
  </div>
}
